import { render, staticRenderFns } from "./CollectionUserSchedule.vue?vue&type=template&id=19cf3d9f&scoped=true&"
import script from "./CollectionUserSchedule.vue?vue&type=script&lang=js&"
export * from "./CollectionUserSchedule.vue?vue&type=script&lang=js&"
import style0 from "./CollectionUserSchedule.vue?vue&type=style&index=0&id=19cf3d9f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cf3d9f",
  null
  
)

export default component.exports